module.exports = __webpack_public_path__ + "img/img-case-001.9b460a73.png";